var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoverImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 152,
    viewBox: "0 0 184 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 182,
    height: 150,
    rx: 11,
    fill: "white",
    stroke: "#A0A0A0",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 168,
    height: 66,
    rx: 6,
    fill: "#B6B6B6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 26,
    width: 26,
    height: 27,
    rx: 8,
    fill: "#D5D5D5",
    stroke: "white",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 61,
    width: 115,
    height: 33,
    rx: 6,
    fill: "#D5D5D5",
    stroke: "white",
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 109,
    width: 50,
    height: 16,
    rx: 4,
    fill: "#D5D5D5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverImage);
export default __webpack_public_path__ + "static/media/coverImage.4837136a4dc743b59403ae978230f023.svg";
export { ForwardRef as ReactComponent };